import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _INTERACTION_STYLE_TO;
export var INTERACTION_BEHAVIOR_TYPE_INTERNAL_LINK = 'INT_LINK';
export var INTERACTION_BEHAVIOR_TYPE_EXTERNAL_LINK = 'EXT_LINK';
export var INTERACTION_BEHAVIOR_TYPE_INTERNAL_LINK_CLICKTHROUGH = 'INT_THRU';
export var INTERACTION_BEHAVIOR_TYPE_EXTERNAL_LINK_CLICKTHROUGH = 'EXT_THRU';
export var INTERACTION_STYLE_PRIMARY = 'PRIMARY';
export var INTERACTION_STYLE_SECONDARY = 'SECONDARY';
export var INTERACTION_STYLE_TEXT = 'TEXT';
export var INTERACTION_DISPLAY_TYPE_BUTTON = 'BUTTON';
export var INTERACTION_DISPLAY_TYPE_ICON = 'ICON';
export var INTERACTION_STYLE_TO_CLASSNAME = (_INTERACTION_STYLE_TO = {}, _defineProperty(_INTERACTION_STYLE_TO, INTERACTION_STYLE_PRIMARY, 'primary'), _defineProperty(_INTERACTION_STYLE_TO, INTERACTION_STYLE_SECONDARY, 'secondary'), _defineProperty(_INTERACTION_STYLE_TO, INTERACTION_STYLE_TEXT, 'default'), _INTERACTION_STYLE_TO);